<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1000 300"
    :width="width"
    :height="height"
    class="trigger-logo"
    aria-label="Trigger"
  >
    <g transform="translate(50, 25)">
      <!-- Icon Scale 0.5 -->
      <g transform="scale(0.5)">
        <path fill="#FFC107" d="M288 32l-160 224h96l-32 224 160-224h-96l32-224z"/>
      </g>
    </g>
    <text
      x="250"
      y="190"
      font-family="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
      font-weight="bold"
      font-size="160"
      fill="currentColor"
    >
      Trigger
    </text>
  </svg>
</template>

<script lang="ts" setup>
defineProps({
  width: {
    type: [Number, String],
    default: undefined,
  },
  height: {
    type: [Number, String],
    default: undefined,
  },
})
</script>

<style scoped>
.trigger-logo {
  display: block; /* Removes bottom space often associated with inline svgs */
}
</style>
